import React from 'react'
import PropTypes from 'prop-types'
import Activity from './Activity'
import TaskActivity from './Task'
import MeetingActivity from './Meeting'
import Note from './Note'

function ActivityType ({ activityType, component, componentProps, activity, ...rest }) {
  if (component) {
    return React.cloneElement(component, {
      activity,
      ...rest,
      ...(componentProps || {})
    })
  }
  if (!activityType) {
    return <Activity activity={activity} {...rest} />
  }
  switch (activityType.toLowerCase()) {
    case 'activity':
      return <Activity activity={activity} {...rest} />
    case 'task':
      return <TaskActivity activity={activity} {...rest} />
    case 'meeting':
      return <MeetingActivity activity={activity} {...rest} />
    case 'note':
      return <Note activity={activity} {...rest} />
    default:
      return <Activity activity={activity} {...rest} />
  }
}

ActivityType.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.any,
    subject: PropTypes.string,
    completed: PropTypes.bool
  }).isRequired,
  activityType: PropTypes.string,
  component: PropTypes.node,
  componentProps: PropTypes.object
}

export default ActivityType
